import styled from 'styled-components';

export const ImageButton = styled.img`
  display: block;
  height: 20px;
  width: 20px;
  margin-left: 0.5rem;
`;
